import React from "react";
import "./styles.scss";

export default props => (
  <a href="https://www.buymeacoffee.com/Nalu">
    <img src="https://img.buymeacoffee.com/button-api/?text=Buy me a coffee&emoji=&slug=Nalu&button_colour=202020&font_colour=ffffff&font_family=Cookie&outline_colour=ffffff&coffee_colour=FFDD00" 
         alt="Buy Nalu a Coffee"/>
  </a>
);
